import React, { useState, useEffect } from "react";
import { useMsal, MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { useLocation } from "react-router-dom";

import { loginRequest, appRoles } from "../authConfig";


export const RouteGuard = ({ ...props }) => {
  const location = useLocation();
  const { instance } = useMsal();
  const [isAuthorized, setIsAuthorized] = useState(false);

  const currentAccount = instance.getActiveAccount();

  const authRequest = {
    ...loginRequest,
  };

  const onLoad = async () => {
    if (currentAccount && currentAccount.idTokenClaims["roles"]) {
      let intersection = props.roles.filter((role) =>
        currentAccount.idTokenClaims["roles"].includes(role)
      );

      if (intersection.length > 0) {
        setIsAuthorized(true);
      }
    }
  };

  useEffect(() => {
    onLoad();
  }, [instance, currentAccount]);

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
    >
      {isAuthorized ? (
        <div>{props.children}</div>
      ) : (
        <div className="data-area-div">
          <h3>
            You are unauthorized to view this content. Please assign yourself to
            the
            {location.pathname === "/customer/*" ? (
              <span>
                {" "}
                role {appRoles.Customer} or {appRoles.Engineer}
              </span>
            ) : (
              <span> role {appRoles.Engineer} </span>
            )}
          </h3>
        </div>
      )}
    </MsalAuthenticationTemplate>
  );
};
